import { render } from "./home-sidebar.vue?vue&type=template&id=c49dc78a"
import script from "./home-sidebar.vue?vue&type=script&lang=js"
export * from "./home-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__